import { Component, Input } from '@angular/core';
import { DEFAULT_DATE_TIME_FORMAT } from 'src/app/core/ccomx-date-formats';
import { TRIP_STATUS_CLASSES } from 'src/app/crew-management-user/models/trip.model';
import { ActivityColor } from 'src/app/shared/enums/activity-color.enum';
import {
  getUserActivityConflictTooltip,
  IUserActivityConflictTooltip,
} from 'src/app/shared/user-view/functions/get-user-activity-conflict-tooltip';
import { getUserActivityStatusKey } from 'src/app/shared/user-view/functions/get-user-activity-status-key';
import { IUserActivityRow } from 'src/app/shared/user-view/models/user-activity.model';

@Component({
  selector: 'app-user-activities-trips-template',
  templateUrl: './user-activities-trips-template.component.html',
  styleUrls: ['./user-activities-trips-template.component.scss'],
  standalone: false,
})
export class UserActivitiesTripsTemplateComponent {
  @Input() columnName: string;
  @Input() element: IUserActivityRow;

  readonly dateTimeFormat = DEFAULT_DATE_TIME_FORMAT;
  readonly emptyValue = '—';

  get activityColor(): ActivityColor | null {
    const color = this.element?.color ?? this.element?.activityColor;
    return color != null ? (color as ActivityColor) : null;
  }

  get hasTrip(): boolean {
    return !!this.element?.tripId;
  }

  get tripStatusKey(): string {
    return TRIP_STATUS_CLASSES[this.element?.tripStatus ?? ''] ?? '';
  }

  get statusKey(): string {
    return getUserActivityStatusKey(this.element.status);
  }

  get showConflictIcon(): boolean {
    return !!this.element?.isConflicted;
  }

  get conflictTooltip(): IUserActivityConflictTooltip {
    return (
      getUserActivityConflictTooltip(this.element) ?? {
        key: 'activityConflict',
        params: {},
      }
    );
  }
}
